module.exports = __webpack_public_path__ + "static/media/structure.eb10371a.png";